export default __webpack_public_path__ + "static/media/location-pin(2).7b3bf856.svg";